import React from "react"
import { Form } from "react-bootstrap"

const RadioInput = ({
  radioBtnList,
  disabled,
  radioTitle,
  selectedValue,
  setSelectedValue,
  name,
  readOnly,
}: {
  radioBtnList: Array<{ value: string | number | undefined; name: string }>
  disabled?: boolean
  radioTitle?: string
  selectedValue: string | number | undefined
  setSelectedValue: Function
  name: string
  readOnly?: boolean
}) => {
  // ループ処理でコンポーネント作成
  const ラジオボタン一覧 = radioBtnList.map((v, index, arr) => {
    return (
      <div
        style={{
          alignItems: "center",
          marginLeft: "20px",
        }}>
        <Form.Check
          id={`${name}_${index}`}
          type="radio"
          name={name}
          label={v.name}
          key={`${name}_${index}`}
          disabled={disabled}
          readOnly={readOnly}
          value={v.value}
          checked={selectedValue === v.value}
          onChange={() => {
            setSelectedValue(v.value)
          }}></Form.Check>
      </div>
    )
  })

  return (
    <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
      {/* ループしてラジオボタンを作成する */}
      {radioTitle && (
        <label style={{ display: "flex", alignItems: "center", margin: "0" }}>
          {radioTitle}
        </label>
      )}
      {ラジオボタン一覧}
    </div>
  )
}

export default RadioInput
